import { Stack } from "@mui/material";
import { Outlet } from "react-router";
import { ActingAsBanner } from "./ActingAsBanner";
import { ConciergeModeBanner } from "./ConciergeModeBanner";

export const ClinicalLayout = () => {
  return (
    <Stack direction="column" sx={{ flex: 1, minWidth: 0 }}>
      <ActingAsBanner />
      <ConciergeModeBanner />
      <Outlet />
    </Stack>
  );
};
